import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { getVerbalColors } from 'helpers'
import { getStatus } from './../../../utils/index'
import { useEsimOperationsContext } from '../../contexts/EsimOperationsContext'
import AssignedForm from './AssignedForm'
import InstallationInstructions from './InstallationInstructions'
import UpdateSimButton from './UpdateSimBtn'
import TerminateSimBtn from './TerminateSimBtn'

const useStyles = makeStyles(theme => {
    const { colors } = theme['foundations-library']
    const verbalColors = getVerbalColors(colors)
    const border = `1px solid ${verbalColors['neutral-200']}`

    return {
        root: {
            border: `1px solid ${verbalColors['neutral-200']}`,
            borderTop: 'none',
            borderRadius: '0 0 10px 10px'
        },
        buttons: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px 0px',
            gap: '20px',
            borderTop: border
        }
    }
})

/**
 *
 */
const Assigned = () => {
    const classes = useStyles()
    const { data } = useEsimOperationsContext(); if (!data) return null
    const [statusText] = getStatus(data)

    return (
        <div className={classes.root}>
            <AssignedForm />
            {(statusText === 'Pending Device Activation') && <InstallationInstructions />}
            {statusText === 'Installed' &&
                <div className={classes.buttons}>
                    <UpdateSimButton />
                    <TerminateSimBtn variant='text'/>
                </div>
            }
        </div>
    )
}

export default Assigned
